import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import * as commonServices from '../services/website.services';
import { capitalizeFirstLetter, setTitle } from "../../../utils/commonfunction";

const DynamicPages = () => {

    const params = useParams();
    const loc = useLocation();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState({});
    const [cmsData, setCmsData] = useState({});

    useEffect(() => {
        setLoading(true);
        commonServices.cmsDetails(params?.slug).then((response) => {
            setData(response?.data);
            setTitle(response?.data?.title);
            setCmsData(response?.data);
            setLoading(false);
        })
            .catch((error) => {
                setLoading(false);
                console.log("error of terms&conditions", error);
            })
    }, [loc, params?.slug])

    return (
        <main>
            <section className="privacy-policy banner-scetion-padding">
                <div className="container">
                    <h1 className="heading-1">{capitalizeFirstLetter(data?.title)}</h1>
                </div>
            </section>
            {/* {loading ? (
                <section className="Conditions-item section-padding">
                    <div className="container" style={{ minHeight: '48vh' }}>
                        <Skeleton count={10} style={{ height: '50px' }} />
                    </div>
                </section>
            ) : (
                <div style={{ minHeight: '70vh' }} dangerouslySetInnerHTML={{ __html: `${data && data?.description ? data?.description : "N/A"}` }}></div>
            )} */}
                <section className="Conditions-item section-padding">
                    <div className="container">
                     <div className="time-update mb-4 editor-preview-style"
                       dangerouslySetInnerHTML={{ __html: `${data && data?.description ? data?.description : "N/A"}` }}>
                     </div>
                    </div>
                </section>
            {/* <section className="Conditions-item section-padding">
                <div className="container">
                    <div className="time-update mb-4">
                        <h6 className="subtitle-1">Effective Date: 28 May 2025</h6>
                        <p className="body-1">
                            Welcome to babe. By using our app or website, you agree to the
                            following terms and conditions. Please read them carefully.
                        </p>
                    </div>
                    <div className="item-box d-flex flex-column gap-4">
                        <div className="content-row">
                            <h5 className="h5-headline">1. Acceptance of Terms</h5>
                            <p className="body-1">
                                By accessing or using the babe app or website, you agree to be
                                bound by these Terms and our Privacy Policy. If you do not
                                agree, please do not use our services.
                            </p>
                        </div>
                        <div className="content-row">
                            <h5 className="h5-headline">2. Services Provided</h5>
                            <p className="body-1">
                                babe provides care coordination and booking services for
                                fertility, postpartum, childcare, and elder care. We do not
                                provide medical advice. All providers are independent and
                                responsible for their own services.
                            </p>
                            <p className="body-1">
                                Lorem Ipsum is simply dummy text of the printing and typesetting
                                industry. Lorem Ipsum has been the industry's standard dummy
                                text ever since the 1500s, when an unknown printer took a galley
                                of type and scrambled it to make a type specimen book.Lorem
                                Ipsum is simply dummy text of the printing and typesetting
                                industry. Lorem Ipsum has been the industry's standard dummy
                                text ever since the 1500s, when an unknown printer took a galley
                                of type and scrambled it to make a type specimen book.Lorem
                                Ipsum is simply dummy text of the printing and typesetting
                                industry. Lorem Ipsum has been the industry's standard dummy
                                text ever since the 1500s,
                            </p>
                            <p className="body-1">
                                when an unknown printer took a galley of type and scrambled it
                                to make a type specimen book.Lorem Ipsum is simply dummy text of
                                the printing and typesetting industry. Lorem Ipsum has been the
                                industry's standard dummy text ever since the 1500s, when an
                                unknown printer took a galley of type and scrambled it to make a
                                type specimen book.Lorem Ipsum is simply dummy text of the
                                printing and typesetting industry. Lorem Ipsum has been the
                                industry's standard dummy text ever since the 1500s, when an
                                unknown printer took a galley of type and scrambled it to make a
                                type specimen book.
                            </p>
                        </div>
                        <div className="content-row">
                            <h5 className="h5-headline">3. User Responsibilities</h5>
                            <ul>
                                <li>Provide accurate and up-to-date information</li>
                                <li>Use the platform legally and respectfully</li>
                                <li>Not misuse or interfere with our services</li>
                            </ul>
                        </div>

                        <div className="content-row">
                            <h5 className="h5-headline">4. Payments and Cancellations</h5>
                            <p className="body-1">
                                Fees for services are displayed prior to booking. Cancellations
                                may be subject to fees as outlined during booking.
                            </p>
                        </div>
                        <div className="content-row">
                            <h5 className="h5-headline">5. Intellectual Property</h5>
                            <p className="body-1">
                                All content, branding, and technology on this platform is the
                                property of babe and may not be copied, modified, or reused
                                without permission.
                            </p>
                        </div>
                        <div className="content-row">
                            <h5 className="h5-headline">6. Limitation of Liability</h5>
                            <p className="body-1">
                                Any damages arising from the use or inability to use our
                                services
                            </p>
                        </div>
                        <div className="content-row">
                            <h5 className="h5-headline">7. Privacy</h5>
                            <p className="body-1">
                                All content, branding, and technology on this platform is the
                                property of babe and may not be copied, modified, or reused
                                without permission.
                            </p>
                        </div>
                    </div>
                </div>
            </section> */}
        </main>
    );
}

export default DynamicPages;
